<template>
    <div class="idea">
        <div class="tab-box">
                <el-tabs v-model="compName"  >
                    <el-tab-pane name="material">
                        <template #label>
                            <span >工单素材<i class="el-icon-refresh" @click="refreshList"/></span>
                        </template>
                    </el-tab-pane>
                    <el-tab-pane label="本地上传" name="upload"/>
                </el-tabs>
        </div>
        <div class="content">
           <keep-alive>
                <component
                    :is="compName"
                    :fileConfigList="fileConfigList"
                    @upload="handleUploadFile"
                    :uploadFileListCancel="uploadFileListCancel"
                    ref="comp"
                    :hasAll="hasAll"
                    :currentKey="currentKey"
                    @cancelUpload="cancelUpload"
                />
           </keep-alive>
        </div>
    </div>
</template>

<script>
import Material from './material.vue'
import Upload from './upload.vue'
import util from '@/libs/utils'
import API from '@/api/marketManage/vivoBatch';
import axios from 'axios';
import COS from '@/libs/cos/Vivo'
import CryptoJS from 'crypto-js';
export default {
    name: 'IdeaBox',
    components: { Material, Upload },
    props: [ 'config', 'currentKey' ],
    inject: {
        addItem: {
            default: ()=>{}
        },
        hasAll: {
            default: false
        }
    },
    data() {
        return {
            compName: 'material',
            uploadFileListCancelData: {},
            updateFileList: [],
        }
    },
    computed: {
        uploadFileListCancel() {
            return this.uploadFileListCancelData[this.currentKey] || []
        },
        fileConfigList() {
            const list = this.config.map(v=> {
                const {
                    material_type, conf_resolution_ratio, conf_resolution,
                    conf_format, conf_size_name, conf_length, explicit_name
                 } = v;
                 const id = util.randomString(20)
                const data = {
                    ...v,
                    id,
                    value: id,
                };
                if (material_type === '1') {
                    data.label = `${ explicit_name }：${conf_resolution}；<=${conf_size_name}；${conf_format}`
                }else {
                    data.label = `${ explicit_name }：${conf_resolution}；<=${conf_size_name}；<=${conf_length/1000}秒；${conf_format}`
                }
                return data
            }).sort((b, a)=> {
                return a.material_type - b.material_type
            });
            const hasData = {};
            const filterList =  list.filter(v=> {
                const has = hasData[v.label];
                if (!has) {
                    hasData[v.label] = true
                }
                return !has;
            });
            if (this.hasAll) {
                const data = {
                    id: 'all',
                    value: 'all',
                    label: '全部'
                };
                filterList.unshift(data)
            }
            return filterList;
        },
    },
    methods: {

        refreshList() {
            if (this.compName === 'material') {
                this.$refs.comp.refreshList()
            }
        },

        // 上传文件

        async handleUploadFile(file, info, media) {
            let cancel = null;
            try {
                const result = await COS.putObject(file, {
                    onTaskReady: (id)=> {
                        let list = this.uploadFileListCancelData[file.key];
                        if (!list) {
                            list = this.uploadFileListCancelData[file.key] = []
                        }
                        list.push(cancel = id);
                        this.$set(this.uploadFileListCancelData, file.key, list)
                    },
                });
                const sha1 = await new Promise((resolve, reject)=> {
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onload = function () {
                        var wordArray = CryptoJS.lib.WordArray.create(reader.result);
                        var hash = CryptoJS.SHA1(wordArray).toString();
                        resolve(hash)
                    };
                });
                const params = {
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    ext: file.name.split('.').pop(),
                    md5: JSON.parse(result.ETag),
                    sha1,
                    file_path: result.path,
                    width:media.width,
                    height:media.height,
                    duration: media.duration,
                    region: result.region,
                };
                const { data } = await API.uploadByJd(params)
                    
                // const formData = new FormData();
                // formData.append('file', file);
                // const { data } = await API.vivoBatchPpload(formData, {
                //     cancelToken: new axios.CancelToken( (c)=> {
                //         const list = this.uploadFileListCancelData[file.key] || []
                //         list.push(cancel = c);
                //         this.$set(this.uploadFileListCancelData, file.key, list)
                //     }),
                //     timeout:3600 * 1000,
                // });
                this.addItem({
                    ...data,
                    key: file.key
                }, 'upload', info)
            } catch (error) {
                if (axios.isCancel(error)) {
                    // 上传取消后的逻辑
                }else {
                    console.log(error, '上传出错');
                    this.$message.error(error.info)
                }

            }finally {
                console.log('-------', file.key, this.uploadFileListCancelData[file.key], cancel);
                
                (this.uploadFileListCancelData[file.key] || []).splice((this.uploadFileListCancelData[file.key] || []).indexOf(cancel), 1);
                if ((this.uploadFileListCancelData[file.key] || []).length === 0) {
                    this.$forceUpdate()
                }
            }
        },
        // 取消全部上传
        cancelUpload() {
            const list = this.uploadFileListCancelData[this.currentKey] || [];
            list.map(v=> {
                try {
                    COS.cancelTask(v)
                } catch (error) {
                    console.log(error, '取消上传出错');
                }
            });
            // this.$message.success('已取消上传');
            this.$set(this.uploadFileListCancelData, this.currentKey, []);
            console.log(this.uploadFileListCancelData, '----');
            this.$forceUpdate()
        }
    }
}
</script>

<style lang="scss" scoped>
.idea {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.tab-box {
    padding-left: 18px;
   height: 55px;
}
.content {
    padding: 0 10px 10px;
    flex: 1;
    height: 0;
}

</style>
